import React, { useEffect, useRef, useState } from "react";
import WebViewer from "@pdftron/webviewer";
import xmljs from "xml-js";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import { useParams } from "react-router";
const FillablePdf = ({ item, setPdfViewer }) => {
  const params = useParams();
  const viewer = useRef(null);
  const [requiredFields, setRequiredFields] = useState([]);
  const [blobData, setBlobData] = useState();

  useEffect(() => {
    let blob;
    function isBase64(str) {
      try {
        return btoa(atob(str)) === str;
      } catch (err) {
        return false;
      }
    }
    try {
      const binaryData = atob(item.file_buffer_encrypted_value);
      const uint8Array = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
      blob = new Blob([uint8Array], { type: "application/pdf" });
      setBlobData(blob);
      // Handle the decoded data here
    } catch (error) {
      console.error("Error decoding Base64:", error);
      // Handle the error gracefully
    }
    // const uint8Array = new Uint8Array(item.file_buffer_encrypted_value.length);

    // for (let i = 0; i < item.file_buffer_encrypted_value.length; i++) {
    //   uint8Array[i] = item.file_buffer_encrypted_value.charCodeAt(i);
    // }
    //   blob = new Blob([uint8Array], { type: 'application/pdf' });
    //   setBlobData(blob)
    let requiredFieldsArray;
    try {
      const parsedXml = xmljs.xml2js(item.field_value, { compact: true });
      const fieldsArray = parsedXml.xfdf["pdf-info"]["ffield"];

      requiredFieldsArray = fieldsArray
        .filter(
          (field) =>
            field._attributes.flags &&
            field._attributes.flags.includes("Required")
        )
        .map((field) => field._attributes.name);
      setRequiredFields(requiredFieldsArray);
    } catch (error) {
      console.error("Error parsing XML:", error);
    }
  }, []); // Empty dependency array to run once on mount

  useEffect(() => {
    if (viewer.current && blobData) {
      WebViewer(
        {
          path: "/webviewer/lib",
        },
        viewer.current
      ).then((instance) => {
        const { documentViewer, annotationManager } = instance.Core;

        const onClickSubmit = async () => {
          const fieldManager = annotationManager.getFieldManager();

          const unfilledRequiredFields = requiredFields.filter((fieldName) => {
            const field = fieldManager.getField(fieldName);
            if (!field || !field.getValue().trim()) {
              return true; // This field is not filled
            }
            return false; // This field is filled
          });

          if (unfilledRequiredFields.length > 0) {
            alert("Please fill all the required fields.");
          } else {
            alert("Form submitted successfully");
            const doc = documentViewer.getDocument();
            const xfdfString = await annotationManager.exportAnnotations();
            const data = await doc.getFileData({
              // saves the document with annotations in it
              xfdfString,
            });
            const arr = new Uint8Array(data);
            const base64String = btoa(String.fromCharCode.apply(null, arr));
            const blobValue = new Blob([arr], { type: "application/pdf" });
            const formData = new FormData();
            // formData.append('mydoc.pdf', blobValue, 'mydoc.pdf');
            formData.append("formfieldid", item.id);
            formData.append("filebuff", blobValue);
            formData.append("filebuffxml", xfdfString);
            formData.append("filebuffencrypted", base64String);
            formData.append(
              "template_id",
              params.tempid !== undefined ? params.tempid : 0
            );
            ApiHelper.post(API.candidateSaveConvertedDocument, formData)
              .then((res) => {
                if (res) {
                  setPdfViewer(false);
                } else {
                  console.log("error saving data");
                }
              })
              .catch((err) => {
                console.log("cached error", err);
              });
          }
        };

        instance.UI.setHeaderItems((header) => {
          const items = header.getItems().slice(0, -0);
          header.update(items);
        });

        instance.UI.setHeaderItems((header) => {
          header.push({
            type: "actionButton",
            img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
            onClick: onClickSubmit,
          });
        });

        instance.UI.loadDocument(blobData, { filename: "myfile.pdf" });
      });
    }
  }, [viewer, blobData, requiredFields]);

  return (
    <div className="webviewer" style={{ height: "800px" }} ref={viewer}></div>
  );
};

export default FillablePdf;
